export const settings = {
  dashboardRoute: '/',
  hasPublicPage: false,
  APP_URL: process.env.REACT_APP_DOMAIN_URL,
  API_URL: process.env.REACT_APP_API_URL,
  RECAPTCHA: process.env.REACT_APP_RECAPTCHA,
  perPage: 12,
  pagination: {
    pageRangeDisplayed: 3,
    hideDisabled: true,
    hideFirstLastPages: false,
    hideNavigation: true,
    linkClassFirst: 'arrow first',
    linkClassPrev: 'arrow prev',
    linkClassNext: 'arrow next',
    linkClassLast: 'arrow last'
  }
}
